import React, { useEffect, useRef, useState } from 'react';
import { MapPin, X } from 'lucide-react';
import { usePractice } from '../context/PracticeContext';
import { formatAddress } from '../data/practice';
import './move-banner.css';

const DISMISS_KEY = 'location_bar_dismissed_v2';
export const STATION_HINT = '2 mins from Lambeth North & Waterloo stations';

const readDismissed = () => {
  try { return sessionStorage.getItem(DISMISS_KEY) === '1'; } catch { return false; }
};

const useAnnounceHeight = (ref, visible) => {
  useEffect(() => {
    const root = document.documentElement;
    if (!visible || !ref.current) {
      root.style.setProperty('--announce-h', '0px');
      return undefined;
    }
    const sync = () => root.style.setProperty('--announce-h', `${ref.current.offsetHeight}px`);
    sync();
    const ro = new ResizeObserver(sync);
    ro.observe(ref.current);
    return () => { ro.disconnect(); root.style.setProperty('--announce-h', '0px'); };
  }, [ref, visible]);
};

// Slim permanent location bar above the header (address comes from Practice Details).
const MoveAnnouncementBanner = () => {
  const practice = usePractice();
  const [dismissed, setDismissed] = useState(readDismissed);
  const ref = useRef(null);
  const visible = practice.announcement_enabled && !dismissed;
  useAnnounceHeight(ref, visible);

  if (!visible) return null;

  const dismiss = () => {
    try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch { /* ignore */ }
    setDismissed(true);
  };

  return (
    <div ref={ref} className="move-banner" role="region" aria-label="Clinic location" data-testid="move-banner">
      <span className="move-banner-tag" aria-hidden="true"><MapPin size={14} strokeWidth={2.5} /> <span className="move-banner-tag-label">Waterloo</span></span>
      <p className="move-banner-msg" data-testid="location-bar-msg">
        <strong>Now Open in Waterloo:</strong> {formatAddress(practice)}
        <span className="move-banner-hint"> ({STATION_HINT}).</span>
      </p>
      <button type="button" className="move-banner-close" onClick={dismiss} aria-label="Dismiss location bar" data-testid="move-banner-dismiss">
        <X size={18} strokeWidth={2.5} />
      </button>
    </div>
  );
};

export default MoveAnnouncementBanner;
